module.exports = __webpack_public_path__ + "static/media/my-health-icon-active.4b7c61ff.svg";